import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {dateSpan} from 'shared/tools';
import moment from 'moment';

class TimeTrackingPayPeriod extends DomainObject {
  startDate;
  endDate;

  previousStartDate;
  previousEndDate;
  nextStartDate;
  nextEndDate;

  _relations = {
    _dates: [
      'startDate',
      'endDate',
      'previousStartDate',
      'previousEndDate',
      'nextStartDate',
      'nextEndDate'
    ],
    previousPayPeriod: TimeTrackingPayPeriod,
    nextPayPeriod: TimeTrackingPayPeriod
  };

  constructor(other) {
    super();

    makeObservable(this, {
      startDate: observable,
      endDate: observable,
      previousStartDate: observable,
      previousEndDate: observable,
      nextStartDate: observable,
      nextEndDate: observable,
      effectiveDateView: computed,
      isCurrentPeriod: computed
    });

    this.merge(other);
  }

  get effectiveDateView() {
    return dateSpan(this.startDate, this.endDate, true);
  }

  get isCurrentPeriod() {
    const now = moment();
    return now.isBetween(this.startDate, this.endDate, 'day', '[]');
  }
}

export default TimeTrackingPayPeriod;
